








































































































import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  authUserStore,
  dataStore,
  systemParameterStore
} from '@/utils/store-accessor'

@Component({
  components: {}
})
export default class CollectionDetailAction extends ComponentVue {
  @Prop({
    type: Boolean,
    default: false
  })
  shouldDisplayAutoLib!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabledAutoLibButton!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  shouldDisplayRegistration!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  shouldDisplayInterLibraryLoanCollection!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabledDisplayChildCollectionListButton!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabledAcceptButton!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  isModal!: boolean

  get shouldDisplayReturnHistoryButton(): boolean {
    return systemParameterStore.isDisplayReturnHistoryButton
  }

  get isAuthUserGroupBibliographyOnlyReference(): boolean {
    return authUserStore.isAuthUserGroupBibliographyOnlyReference
  }

  get displayInterLibraryLoanCollectionRegisterButton(): boolean {
    return dataStore.displayBibliographyDetailPageInterLibraryLoanCollectionRegisterButton
  }

  get displayAcceptButton(): boolean {
    return dataStore.displayBibliographyDetailPageDisplayAcceptButton
  }

  get displayRegisterButton(): boolean {
    return dataStore.displayBibliographyDetailPageDisplayRegisterButton
  }

  get displayOrderButton(): boolean {
    return dataStore.displayBibliographyDetailPageDisplayOrderButton
  }

  @Emit('inter-library-loan-collection')
  onClickRegisterInterLibraryLoanCollection(): void {}

  @Emit('accept')
  onClickAccept(): void {}

  @Emit('lend-count-confirm')
  onClickLendCountConfirm(): void {}

  @Emit('return-history')
  onClickReturnHistory(): void {}

  @Emit('child-collection-list')
  onClickChildCollectionList(): void {}

  @Emit('edit')
  onClickEdit(): void {}

  @Emit('registration')
  onClickRegistration(): void {}

  @Emit('order')
  onClickOrder(): void {}

  @Emit('auto-lib')
  onClickAutoLib(): void {}
}
